import * as React from 'react';
import { getSelectedConcretes } from 'PyzShopUi/scripts/product-detail-page/includes/variant-helper/variantMap';
import { IVariantFilter, VariantMap } from 'PyzShopUi/scripts/product-detail-page/interfaces';

export interface IAttributeSelectionProps {
    filters: IVariantFilter[];
    variantMap: VariantMap;
    onSelectConcrete: (selectedConcrete: number) => void;
    onSelectFilter: (selectedConcretes: Set<number>) => void;
}

export const AttributeSelection: React.FunctionComponent<IAttributeSelectionProps> = props => {
    const {
        filters,
        variantMap,
        onSelectConcrete,
        onSelectFilter
    } = props;

    const onSelectFilterComponent = (
        selectedValue: string,
        selectedFilterType: string,
        disabled: boolean,
        isSelected: boolean
    ): void => {
        if (isSelected) {
            return;
        }

        const currentlySelectedConcretes = getSelectedConcretes(filters, variantMap);
        if (disabled || currentlySelectedConcretes?.size === 0) {
            return;
        }

        onSelectConcrete(currentlySelectedConcretes.values().next().value);
        onSelectFilter(currentlySelectedConcretes);
    };

    return (
        <React.Fragment>
            {
                props.filters.map((filter: IVariantFilter, index: number) => {
                    const FilterComponent = filter.component;
                    return (
                        <FilterComponent
                            key={index}
                            optionList={filter.options}
                            onSelect={onSelectFilterComponent}
                            variants={variantMap}
                        />
                    );
                })
            }
        </React.Fragment>
    );
};
